<template>
  <div
    class="background-visuals shutter-visual"
    :class="{ 'wide-only': wideOnly, 'centered': centered }"
  >
    <div
      ref="leftAspirationsShutterVisual"
      class="visual left-aspirations-shutter-visual show"
    ></div>
    <div
      ref="rightAspirationsShutterVisual"
      class="visual right-aspirations-shutter-visual show"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { TimelineMax } from "gsap";

const props = withDefaults(
  defineProps<{
    wideOnly?: boolean;
    centered?: boolean;
  }>(),
  {
    wideOnly: false,
    centered: false,
  },
);

// template refs
const leftAspirationsShutterVisual = ref<HTMLElement | null>(null);
const rightAspirationsShutterVisual = ref<HTMLElement | null>(null);

const close = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=transitioned" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=transitioned" }, autoCss: true },
    0,
  );
};

const open = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=transitioned" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=transitioned" }, autoCss: true },
    0,
  );
};

const center = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=centered" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "+=centered" }, autoCss: true },
    0,
  );
};

const uncenter = (tl: TimelineMax): void => {
  tl.to(
    leftAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=centered" }, autoCss: true },
    0,
  ).to(
    rightAspirationsShutterVisual.value as HTMLElement,
    0.5,
    { css: { className: "-=centered" }, autoCss: true },
    0,
  );
};

defineExpose({
  close,
  open,
  center,
  uncenter,
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import (reference) "../../styles/sessions/session-variables.less";
@import (reference) "../../styles/sessions/session-layout-mixins.less";

.left-aspirations-shutter-visual.left-aspirations-shutter-visual {
  top: 0;
  left: 0;
  width: 0;
  height: 150%;
  background-color: @session-shutter-grey-color;
}

.right-aspirations-shutter-visual.right-aspirations-shutter-visual {
  top: 0;
  right: 0;
  width: 0;
  height: 150%;
  background-color: white;
}

.session.session-inline {
  .left-aspirations-shutter-visual {
    background-color: white; // Both shutters white when inline

    &.transitioned {
      width: 50%;
    }
  }

  .right-aspirations-shutter-visual {
    z-index: -1;
    &.transitioned {
      width: 52%;
    }
  }

  .shutter-visual.wide-only {
    display: none;
  }
}

.session.session-wide {
  .left-aspirations-shutter-visual.transitioned {
    .slide-sizing();
    padding-right: calc(@text-right-margin + 2vw);
  }

  .right-aspirations-shutter-visual {
    &.transitioned {
      .side-visual-sizing();
    }
  }

  .left-aspirations-shutter-visual.transitioned.centered {
    width: 50vw;
  }

  .right-aspirations-shutter-visual.transitioned.centered {
    width: 50vw;
  }
}
</style>
